<img
  src="assets/images/Logo_Alphalearn_outlines_fluid_animated.svg"
  alt="AlphaLearn"
  class="auth-logo"
/>

<h5 class="twofa-title">{{ 'pages.twofa.setupTitle' | translate }}</h5>
<p class="caption twofa-intro">{{ introKey | translate }}</p>

<app-two-factor-form [forced]="true" (completed)="onCompleted()"></app-two-factor-form>

<p class="engineered-tag">Engineered in Berlin by Alphabees</p>
